import React, { useEffect, useState } from "react";
import { Modal, Form, Input, DatePicker, Row, Col, Radio, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchDoctorAvailability } from "../../Redux/Slice/Doctor/Slots";
import dayjs from "dayjs";
import {
  fetchBookingByRecp,
  rescheduleBookingByRecp,
} from "../../Redux/Slice/Patient/Booking";
import { toast } from "react-toastify";

const { TabPane } = Tabs;

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const RescheduleBookingModal = ({
  open,
  onClose,
  booking,
  branchId,
  handleSearch,
  isSearchActive,
}) => {
  const dispatch = useDispatch();
  const [availability, setAvailability] = useState(null);
  const [form] = Form.useForm();

  const { loading } = useSelector((state) => state.booking?.rescheduleData);

  const fetchAvailability = React.useCallback(
    (doctorId, date) => {
      dispatch(
        fetchDoctorAvailability({
          doctorId,
          interval: 15,
          selectedDate: dayjs(date).format("YYYY-MM-DD"),
        })
      ).then((res) => {
        if (res?.payload) setAvailability(res.payload);
      });
    },
    [dispatch]
  );

  useEffect(() => {
    if (open && booking) {
      form.setFieldsValue({
        doctorName: booking?.doctor?.name,
        speciality: booking?.doctor?.speciality,
        branch: booking?.branch?.branchName,
        appointmentDate: booking?.appointmentDate
          ? dayjs(booking.appointmentDate)
          : null,
        appointmentTime: booking?.appointmentTime,
      });

      if (booking?.doctor?.doctorId && booking?.appointmentDate) {
        fetchAvailability(booking.doctor.doctorId, booking.appointmentDate);
      }
    }
  }, [open, booking, fetchAvailability, form]);

  const handleDateChange = (date) => {
    if (booking?.doctor?.doctorId)
      fetchAvailability(booking.doctor.doctorId, date);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        doctorId: booking.doctor.doctorId,
        appointmentDate: values.appointmentDate.format("YYYY-MM-DD"),
        appointmentTime: values.appointmentTime,
        appointmentId: booking.appointmentId,
      };

      const res = await dispatch(rescheduleBookingByRecp(payload)).unwrap();

      // If API returns success message
      toast.success(res?.message || "Booking rescheduled successfully!");

      // Refresh the booking list

      if (isSearchActive) {
        handleSearch();
      } else {
        dispatch(fetchBookingByRecp({ branchId }));
      }

      // Close modal
      onClose();
    } catch (error) {
      // Handle validation errors or API errors
      toast.error(error?.message || "Something went wrong while rescheduling!");
    }
  };

  const renderSlots = (slots) => {
    if (!slots) return null;

    return slots.map((slot, idx) => {
      const selectedDate = form.getFieldValue("appointmentDate");
      const slotTime = dayjs(
        `${selectedDate?.format("YYYY-MM-DD")} ${slot.start}`
      );
      const isToday = selectedDate?.isSame(dayjs(), "day");
      const isPast = isToday && slotTime.isBefore(dayjs());
      const isBooked = slot.booked === true;

      return (
        <Radio.Button
          key={idx}
          value={slot.start}
          style={{ margin: "4px" }}
          disabled={isPast || isBooked}
        >
          {slotTime.format("hh:mm A")}
        </Radio.Button>
      );
    });
  };

  return (
    <Modal
      title="Reschedule Booking"
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Reschedule"
      width={800}
      style={{ top: 20 }}
      styles={{
        body: { maxHeight: "75vh", overflowY: "auto", overflowX: "hidden" },
      }}
      confirmLoading={loading}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="branch" label="Branch">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="speciality" label="Speciality">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="doctorName" label="Doctor">
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          {/* <Col span={12}> */}
          <Form.Item
            name="appointmentDate"
            label="Appointment Date"
            rules={[{ required: true }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              disabledDate={(current) =>
                current && current < dayjs().startOf("day")
              }
              onChange={handleDateChange}
            />
          </Form.Item>
          {/* </Col>

          <Col span={12}> */}
          <Form.Item
            name="appointmentTime"
            label="Appointment Time"
            rules={[{ required: true }]}
          >
            {availability ? (
              <Tabs defaultActiveKey="Morning">
                {Object.keys(availability).map((session) => (
                  <TabPane tab={capitalize(session)} key={session}>
                    <Form.Item name="appointmentTime">
                      <Radio.Group>
                        {renderSlots(availability[session]?.available)}
                      </Radio.Group>
                    </Form.Item>
                  </TabPane>
                ))}
              </Tabs>
            ) : (
              <p style={{ color: "#888" }}>
                Select a date to view available slots
              </p>
            )}
          </Form.Item>
          {/* </Col> */}
        </Row>
      </Form>
    </Modal>
  );
};

export default RescheduleBookingModal;
